import { render, staticRenderFns } from "./AddPatientModal.vue?vue&type=template&id=49d93264"
import script from "./AddPatientModal.vue?vue&type=script&lang=js"
export * from "./AddPatientModal.vue?vue&type=script&lang=js"
import style0 from "./AddPatientModal.vue?vue&type=style&index=0&id=49d93264&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports